import { Controller } from "@hotwired/stimulus"

// Example usage on single value collapse checkbox select :
// <ul id="scroll-container2" class="sidenav-menu overflow-auto" data-controller="collapse-nested-options">
// <li class="sidenav-item"
//  <ul class="collapse sidenav-collapse pt-3 px-3 pb-0" data-collapse-nested-options-source="true" data-action="collapse-nested-options#setOptions" data-collapse-nested-options-target="#community">
//    <div class="form-check mb-2" data-sidenav-link="">
//     <input class="form-check-input" type="checkbox" name="advance_search_member_profiles_form  [religion][]" value="Hindu" id="religion_0" data-action="input->collapse-nested-options#setOptions" data-collapse-nested-options-target="#community">
//     <label class="form-check-label font-size-14 text-dark" for="religion_0">
//       Hindu
//     </label>
//  </div>
//  </ul>
//  <ul class="collapse sidenav-collapse pt-3 px-3 pb-0" data-collapse-nested-options-target-key="#community" data-collapse-nested-options-groups="<%= MemberProfile::COMMUNITIES.to_json %>" data-collapse-nested-options-empty-label="Select Religion First" data-collapse-nested-options-selected-values-value="<%= Array(f.object.send(field)).to_json %>"
//    <div data-collapse-nested-options-container>Select parent firs</div>
//  </ul>
// </li>
//</ul>

// It is used for: Religion > Community, Country > State

export default class extends Controller {
  connect() {
    console.log("collapse-nested-options#connect")

    const sources = this.element.querySelectorAll(
      "[data-collapse-nested-options-target]"
    )
    let anySelected = false

    sources.forEach((source) => {
      if (source.checked) {
        anySelected = true
        this.setOptions(null, source)
      }
    })

    if (!anySelected) {
      sources.forEach((source) => {
        const container = this.getContainer(source)
        const targetElement = this.getTargetElement(container)
        const containerElement = this.getTargetContainer(targetElement)

        if (containerElement) {
          const emptyLabel =
            targetElement?.dataset.collapseNestedOptionsEmptyLabel ||
            "Select parent first"
          containerElement.innerHTML = `<div class="text-muted small mb-2">${emptyLabel}</div>`
        }
      })
    }
  }

  setOptions(event, sourceFromInitializer = null) {
    const checkbox = event?.currentTarget || sourceFromInitializer
    const container = this.getContainer(checkbox)
    if (!container) return

    const checkedInputs = container.querySelectorAll(
      'input[type="checkbox"]:checked'
    )
    const selectedFields = Array.from(checkedInputs).map((el) => el.value)

    const targetElement = this.getTargetElement(container)
    if (!targetElement) return

    const containerElement = this.getTargetContainer(targetElement)
    if (!containerElement) return

    const emptyLabel =
      targetElement.dataset.collapseNestedOptionsEmptyLabel ||
      "Select parent first"
    const groupDataRaw = targetElement.dataset.collapseNestedOptionsGroups
    if (!groupDataRaw) return

    const groupData = JSON.parse(groupDataRaw)
    const filteredValues = selectedFields.flatMap(
      (field) => groupData[field] || []
    )

    const previouslyChecked = Array.from(
      containerElement.querySelectorAll('input[type="checkbox"]:checked')
    ).map((input) => input.value)

    const formValuesRaw = JSON.parse(
      targetElement.dataset.collapseNestedOptionsSelectedValuesValue || "[]"
    )
    const formValues = new Set(formValuesRaw)

    containerElement.innerHTML = ""

    if (selectedFields.length === 0) {
      containerElement.innerHTML = `<div class="text-muted small mb-2">${emptyLabel}</div>`
      return
    }

    if (filteredValues.length === 0) {
      containerElement.innerHTML = `<div class="text-muted small mb-2">N/A</div>`
      return
    }

    const uniqueValues = new Set(filteredValues)

    const fieldKey =
      targetElement.dataset.collapseNestedOptionsTargetKey.replace("#", "")

    uniqueValues.forEach((value, index) => {
      const id = `${fieldKey}_${value
        .replace(/\s+/g, "_")
        .toLowerCase()}_${index}`

      const div = document.createElement("div")
      div.classList.add("form-check", "mb-2")
      div.setAttribute("data-sidenav-link", "")

      const input = document.createElement("input")
      input.classList.add("form-check-input")
      input.type = "checkbox"
      input.name = `advance_search_member_profiles_form[${fieldKey}][]`
      input.value = value
      input.id = id

      if (previouslyChecked.includes(value) || formValues.has(value)) {
        input.checked = true
      }

      const label = document.createElement("label")
      label.classList.add("form-check-label", "font-size-14", "text-dark")
      label.setAttribute("for", id)
      label.textContent = value

      div.appendChild(input)
      div.appendChild(label)
      containerElement.appendChild(div)
    })
  }

  getContainer(source) {
    return source?.closest("[data-collapse-nested-options-source]")
  }

  getTargetElement(container) {
    if (!container) return null
    const targetKey = container.dataset.collapseNestedOptionsTarget
    if (!targetKey) return null
    const escapedKey = CSS.escape(targetKey)
    return document.querySelector(
      `ul[data-collapse-nested-options-target-key='${escapedKey}']`
    )
  }

  getTargetContainer(targetElement) {
    return targetElement?.querySelector(
      "[data-collapse-nested-options-container]"
    )
  }
}
